// StatusModal.jsx
import React from 'react';

const StatusModal = ({ isOpen, onClose, message, isSuccess }) => {
  if (!isOpen) return null;

  const bgColor = isSuccess ? 'bg-green-500' : 'bg-red-500';
  const hoverColor = isSuccess ? 'hover:bg-green-600' : 'hover:bg-red-600';
  const borderColor = isSuccess ? 'border-green-500' : 'border-red-500';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className={`bg-white border-t-4 ${borderColor} rounded-lg shadow-lg p-6 w-96`}>
        <p className="text-sm text-gray-700 mb-4">{message}</p>
        <button
          onClick={onClose}
          className={`${bgColor} text-white px-4 py-2 rounded ${hoverColor} transition`}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default StatusModal;
